module.exports = __webpack_public_path__ + "static/media/subscription-plans.5f41c445.svg";